export default "__VITE_ASSET__SlBIQ36w__"